import { FullFooter } from '@/components/Footer';
import SubscribeForm from '@/components/SubscribeForm';

const Home = ({ showToast, onSubscribe }) => {
  return (
    <>
      <section className="hero" data-testid="hero-section">
        <div className="hero-left">
          <div className="hero-eyebrow animate-in">Crypto Treasury Company Analysis</div>
          <h1 className="animate-in delay-1">We track every company buying crypto</h1>
          <p className="animate-in delay-2">One newsletter, every Tuesday. Treasury companies, Bitcoin, and the macro forces behind the biggest moves in crypto.</p>
          <p className="animate-in delay-2">Written by a practitioner who has been in this market since 2013.</p>
          <div className="animate-in delay-3" data-testid="hero-subscribe-form">
            <SubscribeForm showToast={showToast} />
          </div>
          <p className="hero-note">Join 50+ crypto investors getting weekly analysis.</p>
        </div>
        <div className="hero-right">
          <div className="hero-right-content">
            <div className="big-number animate-in">10+</div>
            <div className="big-label animate-in delay-1">Years in Crypto Markets</div>
            <div className="live-stats animate-in delay-2">
              <div className="live-stat">
                <div className="val">4</div>
                <div className="lbl">Cycles Survived</div>
              </div>
              <div className="live-stat">
                <div className="val">2</div>
                <div className="lbl">Companies Built</div>
              </div>
              <div className="live-stat">
                <div className="val">100+</div>
                <div className="lbl">DATs Tracked</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="divider-bar" data-testid="divider-bar">
        <span className="item">Bitcoin</span>
        <span className="item">Ethereum</span>
        <span className="item">Solana</span>
        <span className="item">Treasury Companies</span>
        <span className="item">Macro</span>
        <span className="item">Altcoins</span>
      </div>

      <section className="tiers" data-testid="tiers-section" style={{ padding: '60px 56px' }}>
        <div className="section-tag">What You Get</div>
        <h2 className="section-title">One letter. Two sections. Every Tuesday.</h2>
        <p className="section-sub">Everything we publish, free to read.</p>

        <div style={{ maxWidth: '800px', margin: '32px auto 0' }}>
          <div style={{
            background: 'var(--cream)', border: '2px solid var(--purple)', borderRadius: '14px',
            padding: '32px 36px', textAlign: 'center', marginBottom: '16px',
          }}>
            <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--purple)', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '8px' }}>The Newsletter</div>
            <h3 style={{ fontSize: '22px', fontWeight: 800, color: 'var(--ink)', marginBottom: '8px' }}>NC Weekly Letter</h3>
            <p style={{ fontSize: '15px', color: 'var(--text-mid)', lineHeight: 1.6, maxWidth: '500px', margin: '0 auto' }}>Treasury company moves, crypto market shifts, and the macro signals that matter. Delivered every Tuesday.</p>
          </div>

          <div style={{
            textAlign: 'center', fontSize: '12px', fontWeight: 600, color: 'var(--text-light)',
            textTransform: 'uppercase', letterSpacing: '1px', margin: '24px 0 16px',
          }}>What's inside</div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div style={{
              background: 'white', border: '1px solid var(--border)', borderRadius: '12px',
              padding: '28px', textAlign: 'left',
            }}>
              <div style={{ fontSize: '28px', fontWeight: 800, color: 'var(--purple)', marginBottom: '10px' }}>01</div>
              <h4 style={{ fontSize: '16px', fontWeight: 700, color: 'var(--ink)', marginBottom: '8px' }}>Idea of the Week</h4>
              <p style={{ fontSize: '14px', color: 'var(--text-mid)', lineHeight: 1.6, margin: 0 }}>One investment idea or framework worth your attention this week.</p>
            </div>
            <div style={{
              background: 'white', border: '1px solid var(--border)', borderRadius: '12px',
              padding: '28px', textAlign: 'left',
            }}>
              <div style={{ fontSize: '28px', fontWeight: 800, color: 'var(--purple)', marginBottom: '10px' }}>02</div>
              <h4 style={{ fontSize: '16px', fontWeight: 700, color: 'var(--ink)', marginBottom: '8px' }}>Treasury Watch</h4>
              <p style={{ fontSize: '14px', color: 'var(--text-mid)', lineHeight: 1.6, margin: 0 }}>Who's buying or selling, how much, and what it means.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="topics" data-testid="topics-section">
        <div className="section-tag">Coverage</div>
        <h2 className="section-title">Markets We Analyse</h2>
        <p className="section-sub" style={{ marginBottom: '40px' }}>From macro policy to balance sheet accumulation — the signals that move crypto markets.</p>
        <div className="topics-strip">
          <div className="topic-pill">
            <div className="t-icon">
              <svg viewBox="0 0 24 24" fill="#F7931A" fillRule="evenodd" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.638 14.904c-1.602 6.43-8.113 10.34-14.542 8.736C2.67 22.05-1.244 15.525.362 9.105 1.962 2.67 8.475-1.243 14.9.358c6.43 1.605 10.342 8.115 8.738 14.548v-.002zm-6.35-4.613c.24-1.59-.974-2.45-2.64-3.03l.54-2.153-1.315-.33-.525 2.107c-.345-.087-.705-.167-1.064-.25l.526-2.127-1.32-.33-.54 2.165c-.285-.067-.565-.132-.84-.2l-1.815-.45-.35 1.407s.975.225.955.236c.535.136.63.486.615.766l-1.477 5.92c-.075.166-.24.406-.614.314.015.02-.96-.24-.96-.24l-.66 1.51 1.71.426.93.242-.54 2.19 1.32.327.54-2.17c.36.1.705.19 1.05.273l-.51 2.154 1.32.33.545-2.19c2.24.427 3.93.257 4.64-1.774.57-1.637-.03-2.58-1.217-3.196.854-.193 1.5-.76 1.655-1.95l.012-.017zm-2.95 4.135c-.404 1.64-3.157.75-4.05.53l.72-2.9c.896.23 3.757.67 3.33 2.37zm.41-4.24c-.37 1.49-2.662.735-3.405.55l.654-2.64c.744.18 3.137.524 2.75 2.084v.006z"/>
              </svg>
            </div>
            <h4>Bitcoin</h4>
          </div>
          <div className="topic-pill">
            <div className="t-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1.75L4.5 13.25L12 17.25V1.75Z" fill="#627EEA"/>
                <path d="M12 1.75L19.5 13.25L12 17.25V1.75Z" fill="#627EEA" fillOpacity="0.6"/>
                <path d="M4.5 14.25L12 22.25V18.75L4.5 14.25Z" fill="#627EEA" fillOpacity="0.8"/>
                <path d="M19.5 14.25L12 22.25V18.75L19.5 14.25Z" fill="#627EEA" fillOpacity="0.4"/>
              </svg>
            </div>
            <h4>Ethereum</h4>
          </div>
          <div className="topic-pill">
            <div className="t-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/><line x1="12" y1="12" x2="12" y2="16"/><line x1="10" y1="14" x2="14" y2="14"/></svg>
            </div>
            <h4>Treasury Cos</h4>
          </div>
          <div className="topic-pill">
            <div className="t-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
            </div>
            <h4>Global Macro</h4>
          </div>
          <div className="topic-pill">
            <div className="t-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>
            </div>
            <h4>Altcoins</h4>
          </div>
          <div className="topic-pill">
            <div className="t-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            </div>
            <h4>Risk</h4>
          </div>
        </div>
      </section>

      <section className="bottom-cta" data-testid="bottom-cta">
        <h2>Start with the free newsletter.</h2>
        <p>No credit card. No commitment. Just good analysis, every Tuesday.</p>
        <SubscribeForm showToast={showToast} className="cta-centered" />
      </section>

      <FullFooter onSubscribe={onSubscribe} />
    </>
  );
};

export default Home;
